<template>
	<el-dialog
		title="调整预算"
		:visible.sync="dialogVisible"
		width="30%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<!-- 表格 -->
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 预算科目 -->
				<el-col :span="24">
					<el-form-item label="预算科目" prop="budgetSubject">
						<el-input v-model="form.budgetSubject" placeholder="请输入预算科目" size="small" />
					</el-form-item>
				</el-col>

				<!-- 当前月度预算 -->
				<el-col :span="24">
					<el-form-item label="当前月度预算(万元)" prop="currentBudget">
						<el-input v-model.number="form.currentBudget" placeholder="请输入当前月度预算" size="small" type="number" />
					</el-form-item>
				</el-col>

				<!-- 调整后月度预算 -->
				<el-col :span="24">
					<el-form-item label="调整后月度预算(万元)" prop="adjustedBudget">
						<el-input v-model.number="form.adjustedBudget" placeholder="请输入调整后预算" size="small" type="number" />
					</el-form-item>
				</el-col>

				<!-- 调整原因 -->
				<el-col :span="24">
					<el-form-item label="调整原因" prop="adjustReason">
						<el-input v-model="form.adjustReason" type="textarea" :rows="4" placeholder="请输入调整原因" size="small" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'BudgetManagementAdjustDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					budgetSubject: '',
					currentBudget: '',
					adjustedBudget: '',
					adjustReason: '',
				},
				rules: {
					adjustedBudget: [{ required: true, message: '请输入调整后月度预算', trigger: 'blur' }],
					adjustReason: [{ required: true, message: '请输入调整原因', trigger: 'blur' }],
				},
			};
		},
		created() {},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
